<!-- MODAL seleccionarDocumento -->
<div mdbModal #seleccionarDocumento="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-xl" role="document">
    <form autocomplete="off" [formGroup]="formData" (ngSubmit)="buscarTodos(true)">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Seleccionar documento
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="seleccionarDocumento.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col" style="max-width: 200px;">
              <div class="md-form">
                <input value="" type="text" id="monto" class="form-control" placeholder="Monto Ajuste" disabled required
                  #folio formControlName="monto" />
                <label for="monto">Monto Maximo de Ajuste</label>
              </div>
            </div>
            <!-- <div class="col dato" style="max-width: 150px;">
              <div class="md-form">
                <mdb-date-picker [inline]="true" name="fechaInicio" [placeholder]="'Fecha Desde'" required
                  formControlName="fechaDesde">
                </mdb-date-picker>
              </div>
            </div>
            <div class="col dato" style="max-width: 150px;">
              <div class="md-form">
                <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Fecha hasta'" required
                  formControlName="fechaHasta">
                </mdb-date-picker>
              </div>
            </div> -->
            <!-- <div class="col dato" style="max-width: 200px;">
              <div class="md-form">
                <input value="" type="text" id="nombre" class="form-control" placeholder="" required #nombre
                  formatRut formControlName="rut" />
                <label for="nombre">RUT</label>
              </div>
            </div>
            <div class="col dato" style="max-width: 300px;">
              <div class="md-form">
                <input value="" type="text" id="nombre" class="form-control" placeholder="" required #nombre
                  formControlName="nombre" />
                <label for="nombre">Nombre cliente</label>
              </div>
            </div> -->
          </div>



          <div class="row justify-content-between" style="border-top: 1px solid #dee2e6;">
            <div></div>
            <button mdbBtn type="submit" size="sm" color="info" mdbWavesEffect>
              <mdb-icon fas icon="search"></mdb-icon>
              Buscar
            </button>
          </div>

          <div class="row text-center" *ngIf="loading">
            <div class="col">
              <mdb-spinner spinnerColor="blue"></mdb-spinner>
            </div>
          </div>

          <div class="row" *ngIf="busquedaIniciada && listaMovimientos.length === 0">
            <div class="col">
              <p color="info" class="waves-light" style="text-align-last:center;" mdbWavesEffect>
                No existen registros para el filtro seleccionado</p>
            </div>
          </div>

          <div class="table-responsive" *ngIf="busquedaIniciada && listaMovimientos.length > 0">
            <table class="table table-striped table-hover table-sm align-middle mt-1">
              <thead class="grey lighten-2">
                <tr>
                  <th scope="col">
                    <mdb-checkbox [checked]="true" (change)="checkAllChange($event)"></mdb-checkbox>
                  </th>
                  <th scope="col">RUT</th>
                  <th scope="col">Cliente</th>
                  <th scope="col">Nro. Doc.</th>
                  <th scope="col">Tip. Doc.</th>
                  <th scope="col">Fecha</th>
                  <th scope="col" class="text-right">Monto</th>
                  <th scope="col" class="text-right">Deuda</th>
                  <th scope="col" class="text-center">Rec.</th>
                  <th scope="col" class="text-center">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let doc of listaMovimientos" [ngClass]="{'fila-no-ajustable': !puedeAjustar(doc)}">
                  <td>
                    <mdb-checkbox [checked]="doc.additionalInfo.checked" [disabled]="!puedeAjustar(doc)"
                      (change)='checkDetalle(doc.additionalInfo)'>
                    </mdb-checkbox>
                  </td>
                  <td>{{ doc.rutFormato | rut}}</td>
                  <td>{{ doc.razonSocialCliente }}</td>
                  <td>{{ doc.folio }}</td>
                  <td>{{ doc.documento }}</td>
                  <td>{{ doc.fecha_emision | date }}</td>
                  <td class="text-right">$ {{ doc.monto | numerico }}</td>
                  <td class="text-right">$ {{ doc.saldo | numerico }}</td>
                  <!-- Mostrar un guión si no existe recorrido, para mejor legibilidad -->
                  <td class="text-center">
                    {{ doc.recorrido_codigo && doc.recorrido_codigo > 0 ? (doc.recorrido_codigo | numerico) : '-' }}
                  </td>
                  <td class="text-center">
                    <mdb-badge *ngIf="doc.estado_recorrido && doc.estado_recorrido.toLowerCase() === 'despachado'"
                      pill="true" class="estado-despachado">
                      despachado</mdb-badge>
                    <mdb-badge *ngIf="doc.estado_recorrido && doc.estado_recorrido.toLowerCase() === 'liquidado'"
                      pill="true" class="estado-liquidado">
                      liquidado</mdb-badge>
                    <span
                      *ngIf="!doc.estado_recorrido || (doc.estado_recorrido && doc.estado_recorrido.toLowerCase() !== 'despachado' && doc.estado_recorrido.toLowerCase() !== 'liquidado')">
                      {{ doc.estado_recorrido }}
                    </span>
                  </td>
                  <!-- <td>
                  <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                    (click)="selectData(documento)">
                    Seleccionar
                  </button>
                </td> -->
                </tr>
              </tbody>
              <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
                *ngIf="listaMovimientos?.length > 0"></app-pagination>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between" *ngIf="busquedaIniciada && listaMovimientos.length > 0">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
            (click)="seleccionarDocumento.hide()" mdbWavesEffect>
            Cerrar
          </button>
          <app-api-button (click2)="ajustar()" [processing]="processing">
            Ajustar Doc.
          </app-api-button>
        </div>
      </div>
    </form>
  </div>
</div>
